module.exports = __webpack_public_path__ + "img/notificare_expirare.e2a0dda5.svg";